// AuthTimeout.jsx
import { useEffect, useRef } from "react";

const AuthTimeout = ({ user }) => {
  const timeoutRef = useRef(null);
  const didLogoutRef = useRef(false);

  const clearAuthKeys = () => {
    localStorage.removeItem("auth");
    localStorage.removeItem("authExpiry");
    localStorage.removeItem("user");
  };

  const doLogoutOnce = () => {
    if (didLogoutRef.current) return;
    didLogoutRef.current = true;
    clearAuthKeys();
    window.location.replace("/login");
  };

  const scheduleLogoutFromLocalStorage = () => {
    const token = localStorage.getItem("auth");
    const expiry = localStorage.getItem("authExpiry");
    if (!token || !expiry) return;

    const msLeft = Number(expiry) - Date.now();

    if (msLeft <= 0) {
      doLogoutOnce();
      return;
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      doLogoutOnce();
    }, msLeft);
  };

  useEffect(() => {
    scheduleLogoutFromLocalStorage();

    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []); 
  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (user) {
      scheduleLogoutFromLocalStorage();
    }
  }, [user]);

  return null;
};

export default AuthTimeout;
